//routes

import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/inicio/index.jsx";
import SinglePost from "./components/posts/singlePost.jsx";
import Autoridades from "./components/institucional/autoridades.jsx";
import Noticias from "./components/noticias/index.jsx";
import Audiencia from "./components/servicios/audiencia.jsx";
import Tarifario from "./components/servicios/sistemaTarifario.jsx";
import InformacionPublica from "./components/servicios/informacionPublica.jsx";
import Operadores from "./components/servicios/operadores.jsx";
import Permisos from "./components/servicios/permisosPerforacion.jsx";
import Obras from "./components/servicios/obras.jsx";
import Solicitud from "./components/servicios/solicitud.jsx";
import MarcoRegulatorio from "./components/servicios/marcoRegulatorio.jsx";
import Reclamos from "./components/servicios/reclamos.jsx";
// Exportar rutas para usar dinámicamente
import ResolucionesRegulatorias from "./components/servicios/resolucionesRegulatorias.jsx";
export const ROUTES = {
    home: { path: "/", name: "Inicio" },
    autoridades: { path: "/institucional/autoridades", name: "Autoridades" },
    noticias: { path: "/noticias", name: "Noticias" },
    publicaLey: { path: "/informacionPublica/LeyDecreto", name: "Ley n° 9070 y decreto" },
    publicaResponsabilidad: { path: "/informacionPublica/responsabilidad", name: "Responsabilidad fiscal" },
    audiencia: { path: "/audienciaPublica", name: "Audiencia Pública" },
    tarifario: { path: "/sistemaTarifario", name: "Sistema Tarifario" },
    informacionPublica: { path: "/informacionPublica", name: "Informacion Pública" },
    operadores: { path: "/operadores", name: "Operadores" },
    permisos: { path: "/permisosPerforacion", name: "Factibilidades y Permisos de Perforación" },
    obras: { path: "/obras", name: "Obras" },
    solicitud: { path: "/solicitud", name: "Solicitud Constitución Operador" },
    noticiasId: { path: "/noticias/:id", name: "Noticias" },
    resolucionesRegulatorias: { path: "/resoluciones-regulatorias", name: "Resoluciones regulatorias" },
    marcoRegulatorio: { path: "/marco-regulatorio", name: "Marco regulatorio" },
    reclamos: { path: "/reclamos", name: "Reclamos" },

};

const AppRoutes = () => {
    return (
        <Routes>
            <Route path={ROUTES.home.path} element={<Home />} />
            <Route path={ROUTES.autoridades.path} element={<Autoridades />} />
            <Route path={ROUTES.noticias.path} element={<Noticias />} />
            <Route path={ROUTES.noticiasId.path} element={<SinglePost />} />
            <Route path={ROUTES.audiencia.path} element={<Audiencia />} />
            <Route path={ROUTES.tarifario.path} element={<Tarifario />} />
            <Route path={ROUTES.informacionPublica.path} element={<InformacionPublica />} />
            <Route path={ROUTES.operadores.path} element={<Operadores />} />
            <Route path={ROUTES.permisos.path} element={<Permisos />} />
            <Route path={ROUTES.solicitud.path} element={<Solicitud />} />
            <Route path={ROUTES.obras.path} element={<Obras />} />
            <Route path={ROUTES.resolucionesRegulatorias.path} element={<ResolucionesRegulatorias />} />
            <Route path={ROUTES.marcoRegulatorio.path} element={<MarcoRegulatorio />} />
            <Route path={ROUTES.reclamos.path} element={<Reclamos />} />
        </Routes>
    );
};

export default AppRoutes;